import { Deserializable } from '../interfaces';

export class Charges implements Deserializable {
  descripcion: string | null;
  esMx: number | null;
  id: number | null;
  idPaquete: number | null;
  importe: number | null;
  moneda: string | null;
  periodoFinal: string | null;
  periodoInicial: string | null;

  constructor() {
    this.descripcion = null;
    this.esMx = null;
    this.id = null;
    this.idPaquete = null;
    this.importe = null;
    this.moneda = null;
    this.periodoFinal = null;
    this.periodoInicial = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
